import cloneDeep from 'lodash.clonedeep';
import trim from 'lodash.trim';
import debounce from 'lodash.debounce';
import compact from 'lodash.compact';
import round from 'lodash.round';
import orderBy from 'lodash.orderby';
import set from 'lodash.set';

export { cloneDeep, trim, debounce, compact, round, orderBy, set };

export const get = (obj, path, defaultValue = undefined) => {
  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

export const pick = (object, keys) => {
  return keys.reduce((obj, key) => {
    if (object && Object.prototype.hasOwnProperty.call(object, key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
};

export const isElement = element => {
  return element instanceof Element || element instanceof HTMLDocument;
};

export const removeKey = (obj, key) =>
  obj !== Object(obj)
    ? obj
    : Array.isArray(obj)
    ? obj.map(item => removeKey(item, key))
    : Object.keys(obj)
        .filter(k => k !== key)
        .reduce((acc, x) => Object.assign(acc, { [x]: removeKey(obj[x], key) }), {});
